// extracted by mini-css-extract-plugin
export default {"SettingsView":"SettingsView_SettingsView__V3ZZP"};